import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getPackages = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `packages${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch packages");
    return error;
  }
};


export const getPackageById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `packages/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch packages");
    return error;
  }
};

export const createPackage = async (data: any, selectedImage) => {
  let formData = new FormData();
  formData.append('data', JSON.stringify(data));
  if (selectedImage) {
    formData.append('featured_image', selectedImage);
  }
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "packages",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create package");
    return error;
  }
};

export const updatePackage = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `packages/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update package");
    return error;
  }
};

export const deletePackage = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `packages/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete package");
    return error;
  }
};


export const getPackageGroups = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `package_groups${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch packages");
    return error;
  }
};

export const createPackageGroup = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "package_groups",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create package");
    return error;
  }
};

export const updatePackageGroup = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `package_groups/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update package");
    return error;
  }
};

export const deletePackageGroup = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `package_groups/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Package deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete package");
    return error;
  }
};